
import Component from "vue-class-component"
import { Prop, Emit } from "vue-property-decorator"
import { mixins } from "vue-class-component"
import Calculator from "@/components/mixins/Calculator.vue"
import { PlisteProduktZeit_PreislisteProdukt as PreislisteProdukt } from "mangdto"

@Component
export default class Artikel extends mixins(Calculator) {
  @Prop() produkt: PreislisteProdukt

  clickProdukt(produkt: PreislisteProdukt) {
    if (!produkt.ausverkauft) this.produktSelected(produkt)
  }

  @Emit("selected")
  produktSelected(produkt: PreislisteProdukt) {}

  berechneStandardpreis(produkt: PreislisteProdukt): number {
    if (produkt.hasArten) {
      var sId = produkt.standardartId
      var preis = 0
      produkt.arten.forEach((v) => {
        if (v.pduktArtId === sId) {
          preis = v.preis
          return
        }
      })
      return preis
    } else {
      return produkt.preis
    }
  }
}
